import Link from 'next/link'
import { cn } from '@/lib/utils'

type ButtonVariant = 'primary' | 'secondary' | 'ghost'
type ButtonSize = 'md' | 'lg'

interface ButtonProps {
  href?: string
  prefetch?: boolean
  onClick?: () => void
  type?: 'button' | 'submit'
  variant?: ButtonVariant
  size?: ButtonSize
  className?: string
  children: React.ReactNode
}

const VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary: 'bg-primary text-white hover:bg-primary-hover shadow-card',
  secondary: 'border border-border bg-bg text-ink hover:bg-surface',
  ghost: 'text-primary hover:text-primary-hover',
}

const SIZE_CLASSES: Record<ButtonSize, string> = {
  md: 'h-11 px-5 text-[15px]',
  lg: 'h-12 px-6 text-base',
}

export function Button({
  href,
  prefetch,
  onClick,
  type = 'button',
  variant = 'primary',
  size = 'md',
  className,
  children,
}: ButtonProps) {
  const classes = cn(
    'inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-colors',
    VARIANT_CLASSES[variant],
    SIZE_CLASSES[size],
    className
  )

  if (href) {
    return (
      <Link href={href} prefetch={prefetch} className={classes}>
        {children}
      </Link>
    )
  }

  return (
    <button type={type} onClick={onClick} className={classes}>
      {children}
    </button>
  )
}
